<template>
	<span class="endconfirmlink">
    <button
      type="button"
      class="btn-link"
      @click="showModal"
    >
    <b><u>{{ text }}</u>.</b>
    </button>

    <EndConfirmModalModal ref="modal"
      v-show="isModalVisible"
      v-bind:url="url"
      v-bind:url2="url2"
      v-bind:text="text"
      @close="closeModal"
    />
  </span>
</template>

<script>
import EndConfirmModal from './components/endconfirm_modal.vue'

export default {
	components: {
    EndConfirmModal,
	},
  props: ["url", "url2", "text"],
  data() {
    return {
      isModalVisible: false,
    }
  },
  methods: {
    submit(){
      console.log(this);
    },
    showModal() {
     this.isModalVisible = true;
    },
    closeModal() {
     this.isModalVisible = false;
    },
  }
}
</script>

<style lang="scss">

*, *::before, *::after {
	box-sizing: border-box;
}

#endconfirmlink {
	margin: 0 auto;
	line-height: 1.4;
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

h1 {
	text-align: center;
}
</style>
